var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"committee"},[_c('PageBanner',{attrs:{"bannerObj":_vm.bannerObj}}),_c('div',{staticClass:"contain"},[_c('ComDetails',{attrs:{"infoColumn":_vm.infoColumn,"baseUrl":"committee"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }